









































import { Vue, Component } from 'vue-property-decorator';
import AppBase from '../common/base';

@Component
export default class RepubblicaLanding extends AppBase {
    isLogin = false;

    created() {
        this.$store.commit('setTheme', { theme: this.slug });
    }

    get state() {
        return this.$route.query && this.$route.query.state || '';
    }

    get slug() {
        return this.$route.params.slug;
    }

    get coverImage() {
        return `/_assets/resources/surveys/${this.slug}/landing.jpg`;
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/signup/repubblica-landing.vue